import { render, staticRenderFns } from "./heo-admin.vue?vue&type=template&id=38184711&"
import script from "./heo-admin.vue?vue&type=script&lang=js&"
export * from "./heo-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports